module.exports = __webpack_public_path__ + "img/tertiary_7x3_z16.3583b779.svg";